export const PACKAGE_ROUTE = "/create-publication/choose-package";
export const TEMPLATE_ROUTE = "/create-publication/choose-template";
export const BUILD_ROUTE = "/create-publication/build-publication";
export const UPGRADE_PUBLICATION_ROUTE = "/create-publication/upgrade-publication";
export const SELECT_PUBLICATION_DATES_ROUTE = "/create-publication/select-publication-dates";
export const ADD_SOCIAL_MEDIA_ROUTE = "/create-publication/add-social-media";
export const SOCIAL_MEDIA_SETTINGS = "/create-publication/social-media-settings";
export const CHECKOUT_ROUTE = "/review-order";
